import { Component, OnInit, Input } from "@angular/core";
import { FlightCheckInComponent } from "@ibe.components/booking/flights/flight-check-in/flight-check-in.component";
import { CHECK_IN_STATUS_OPEN, CHECK_IN_STATUS_DONE, CHECK_IN_STATUS_CLOSED, CHECK_IN_STATUS_PENDING } from "@ibe.config";
import { INDRAFlightCheckIn } from "@ibe.models/flight-checkin.indra.model.lib";
import { INDRADateService } from "@ibe.services/date.indra.service";
import { INDRAIbeAdminConfigService } from "@ibe.services/ibeadmin-config.service";
import { INDRAStorageService } from "@ibe.services/storage.indra.service";

@Component({
	selector: 'app-flight-check-in',
	templateUrl: './flight-check-in.indra.component.html',
	styleUrls: ['./flight-check-in.component.css']
})
export class INDRAFlightCheckInComponent extends FlightCheckInComponent
	implements OnInit {

	@Input()
	flight_check_in: INDRAFlightCheckIn;

	@Input()
	dateDeparture: string;

	@Input()
	pnrData: string;

	private flight_check_in_status: String = '';

	checkInDate: string;

	constructor(private dateService: INDRADateService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		private storage: INDRAStorageService
		) {
		super();
	}

	ngOnInit() {
		this.flight_check_in_status = this.INDRA_setStatusMessage();
		// this.INDRA_goToUrl('externalURLs.checkInNow');
	}

	INDRA_setStatusMessage(): String {
		switch (this.flight_check_in.status) {
			case CHECK_IN_STATUS_PENDING:
				return 'Check-in opens ' + this.INDRA_getTimeToCheckin();
			case CHECK_IN_STATUS_OPEN:
				return 'Check-in now';
			case CHECK_IN_STATUS_DONE:
				return 'Check-in done';
			case CHECK_IN_STATUS_CLOSED:
				return 'Check-in closed';
			default:
				return;
		}
	}

	INDRA_getStatusMessageTranslated() {
		switch (this.flight_check_in.status) {
			case CHECK_IN_STATUS_PENDING:
				return 'bookingsList.button.checkInOpen';
			case CHECK_IN_STATUS_OPEN:
				return 'bookingsList.button.checkInNow';
			case CHECK_IN_STATUS_DONE:
				return 'bookingsList.button.checkInDone';
			case CHECK_IN_STATUS_CLOSED:
				return 'bookingsList.button.checkInClosed';
			default:
				return;
		}
	}

	INDRA_getDayLabel() {
		if (this.flight_check_in.status === CHECK_IN_STATUS_PENDING || this.flight_check_in.status == 'not available') {
			const timediff = Math.floor(this.dateService.INDRA_getRemainingTimeInSeconds(this.flight_check_in.time));
			const days = Math.floor(timediff / 60 / 60 / 24);
			let dayLabel;
			if (days > 1) {
				dayLabel = this.dateService.INDRA_formatDate(this.flight_check_in.time, 'MMM DD')
			} else if (days === 1) {
				dayLabel = 'bookingsList.text.tomorrow';
			} else if (days <= 0) {
				dayLabel = 'bookingsList.text.today';
			}
			return dayLabel;
		}
	}

	INDRA_getAtLabel() {
		if (this.flight_check_in.status === CHECK_IN_STATUS_PENDING || this.flight_check_in.status == 'not available') {
			return 'bookingsList.text.timeAt';
		}
	}

	INDRA_getAriaLabelMessage(): String {
		switch (this.flight_check_in.status) {
			case 'not available':
				return 'bookingsList.aria.checkInForFlightNotAvailable' + this.INDRA_getTimeToCheckin();
			case CHECK_IN_STATUS_OPEN:
				return 'bookingsList.aria.checkInForFlightIsOpenNow';
			case CHECK_IN_STATUS_DONE:
				return 'bookingsList.aria.checkInIsDone';
			default:
				return;
		}
	}

	// Print aria label for button
	INDRA_printAriaLabelMessage(): String {
		switch (this.flight_check_in.status) {
			case 'not available':
				return 'Check-in for flight is not available yet, it opens ' + this.INDRA_getTimeToCheckin();
			case CHECK_IN_STATUS_OPEN:
				return 'Check-in for flight is open now, click here to open a new window and start check-in process';
			case CHECK_IN_STATUS_DONE:
				return 'Check-in for flight is done';
			default:
				return;
		}
	}

	private INDRA_getTimeToCheckin(): string {
		const timediff = Math.floor(this.dateService.INDRA_getRemainingTimeInSeconds(this.flight_check_in.time));
		const days = Math.floor(timediff / 60 / 60 / 24);
		let dayLabel;

		if (days > 1) {
			dayLabel = this.dateService.INDRA_formatDate(this.flight_check_in.time, 'MMM DD')
		} else if (days === 1) {
			dayLabel = 'Tomorrow';
		} else if (days <= 0) {
			dayLabel = 'Today';
		}

		return (
			dayLabel +
			', at ' +
			this.dateService.INDRA_formatDate(this.flight_check_in.time, 'LT')
		);
	}

	public INDRA_getTimeToCheckInOnly(): string {
		if (this.flight_check_in.status === CHECK_IN_STATUS_PENDING || this.flight_check_in.status == 'not available') {
			const timediff = Math.floor(this.dateService.INDRA_getRemainingTimeInSeconds(this.flight_check_in.time));
			const days = Math.floor(timediff / 60 / 60 / 24);
			// return this.dateService.INDRA_formatDate(this.flight_check_in.time, 'LT');
			return this.dateService.INDRA_formatDate(this.flight_check_in.time, 'HH:mm');
		}

	}

	INDRA_isDone() {
		return this.flight_check_in.status === CHECK_IN_STATUS_DONE;
	}

	INDRA_isDisabled() {
		return this.flight_check_in.status === CHECK_IN_STATUS_CLOSED ? 'true' : null;
	}

	/**
	 * @returns styles for check-in button
	 */
	INDRA_checkInButtonStyles() {
		return {
			'button-accent': this.flight_check_in.status === CHECK_IN_STATUS_OPEN,
			'button-not-available': this.flight_check_in.status === CHECK_IN_STATUS_PENDING || this.flight_check_in.status === CHECK_IN_STATUS_CLOSED,
			'button-possitive-info': this.flight_check_in.status === CHECK_IN_STATUS_DONE
		};
	}

	// Print button message label
	INDRA_printStatusMessage(): String {
		return this.flight_check_in_status;
	}

	INDRA_goToUrl(key: string) {
		const IDepartureDate = this.dateDeparture;
		const PNR = this.pnrData;
		const surname = this.storage.get('lastname');
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${surname}', `${surname}`).replace('${IDepartureDate}', `${IDepartureDate}`).replace('${PNR}', `${PNR}`);
		return window.open(urlNavigate);
	}
}
